module.exports = __webpack_public_path__ + "static/media/presencaOnlineMeis.41a7f25e.png";